import React from 'react';
import Icon from './Icon';

interface EmptyProps {
  title: string;
  description?: string;
  icon?: string;
  action?: React.ReactNode;
}

export default function Empty({ title, description, icon = 'doc', action }: EmptyProps) {
  return (
    <div className="t-empty">
      <div className="empty-icon">
        <Icon name={icon} size={40} color="var(--ink-3)" />
      </div>
      <p className="empty-title">{title}</p>
      {description && <p className="empty-desc">{description}</p>}
      {action}
    </div>
  );
}
